import { stringToSelectOption } from '@shared/select/select.utils';
import { NEW_FILTER } from '../../filters/filters.constants';

export const buildCustomFiltersOptions = customFilters => [
    NEW_FILTER,
    ...customFilters,
].map(({ name }) => stringToSelectOption(name));

export const getConditionsText = (conditionsNumber: number): string => `${conditionsNumber} condition${conditionsNumber === 1 ? '' : 's'}`;
